// apps/web/src/app/layouts/DashboardLayout/components/NotificationToasts.tsx
import { useNotificationToasts } from './useNotificationToasts';

/**
 * Componente que encapsula el hook (para usar en React)
 * Separa el hook en un archivo diferente para que Fast Refresh funcione correctamente
 */
export function NotificationToasts() {
  useNotificationToasts();
  return null;
}

// Re-export hook for convenience
export { useNotificationToasts } from './useNotificationToasts';
